import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Star, Crown, Shield } from 'lucide-react';

const TransfertVIPBruxelles = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Transfert VIP Bruxelles | Chauffeur Privé Haut de Gamme</title>
        <meta name="description" content="Service de transfert VIP à Bruxelles. Chauffeur privé haut de gamme, Mercedes S-Class, Lexus premium. Service discret pour clients exigeants." />
        <meta name="keywords" content="transfert vip bruxelles, chauffeur vip, limousine vip bruxelles, service premium bruxelles, vtc luxe" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/transfert-vip-bruxelles" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <Crown className="w-16 h-16 text-gold mx-auto mb-6" />
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
              Transfert VIP Bruxelles
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Service de chauffeur privé haut de gamme. Mercedes S-Class, Lexus premium. Discrétion et excellence.
            </p>
          </div>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection />
        </div>
      </section>

      <section className="py-16 bg-black">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gold">Service VIP Premium</h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="bg-gray-900 p-6 rounded-lg border border-gold/20">
              <Star className="w-12 h-12 text-gold mb-4" />
              <h3 className="text-xl font-bold mb-3">Véhicules Prestige</h3>
              <p className="text-gray-400">Mercedes S-Class, Lexus ES/LS premium. Intérieur cuir, système audio Burmester.</p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border border-gold/20">
              <Shield className="w-12 h-12 text-gold mb-4" />
              <h3 className="text-xl font-bold mb-3">Discrétion Absolue</h3>
              <p className="text-gray-400">Chauffeurs formés au protocole VIP. Confidentialité garantie.</p>
            </div>
            <div className="bg-gray-900 p-6 rounded-lg border border-gold/20">
              <Crown className="w-12 h-12 text-gold mb-4" />
              <h3 className="text-xl font-bold mb-3">Service Sur-Mesure</h3>
              <p className="text-gray-400">Eau premium, presse, wifi, chargeurs. Tout pour votre confort.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Transfert VIP à Bruxelles</h2>
          <p className="text-gray-300 mb-4">
            <strong>Service de transfert VIP premium</strong> pour une clientèle exigeante. Véhicules haut de gamme, 
            chauffeurs formés au protocole, discrétion absolue. Idéal pour dirigeants, célébrités, diplomates.
          </p>
        </div>
      </section>
    </div>
  );
};

export default TransfertVIPBruxelles;